/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Bright_Horse_LickInputs */

const en_wild_bright_horse_lick = /** @type {(inputs: Wild_Bright_Horse_LickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving changes...`)
};

const de_wild_bright_horse_lick = /** @type {(inputs: Wild_Bright_Horse_LickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichere Änderungen...`)
};

/**
* | output |
* | --- |
* | "Saving changes..." |
*
* @param {Wild_Bright_Horse_LickInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_bright_horse_lick = /** @type {((inputs?: Wild_Bright_Horse_LickInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Bright_Horse_LickInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_bright_horse_lick(inputs)
	return de_wild_bright_horse_lick(inputs)
});